import { useRef, useEffect } from "react";
import "./Services.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import {
  FaPaintBrush,
  FaChartLine,
  FaVectorSquare,
  FaMobileAlt,
  FaHashtag,
  FaCogs,
} from "react-icons/fa";

gsap.registerPlugin(ScrollTrigger);

const services = [
  {
    icon: <FaPaintBrush />,
    title: "Custom Software Development",
    description:"We engineer scalable, robust, and secure enterprise software tailored to your specific workflows. Our custom solutions streamline operations, automate manual tasks, and grow alongside your business demands.",
    image:"https://images.unsplash.com/photo-1522542550221-31fd19575a2d",
  },
  {
    icon: <FaChartLine />,
    title: "Artificial Intelligence & ML",
    description:"We implement smart machine learning models, predictive analytics, and natural language processing solutions. Transform your raw business data into actionable, automated decision-making engines.",
    image:"https://images.unsplash.com/photo-1551288049-bebda4e38f71",
  },
  {
    icon: <FaVectorSquare />,
    title: "IoT Architecture & Engineering",
    description:"We design and deploy end-to-end IoT frameworks. From embedding firmware and sensor integration to setting up edge-computing devices, we bridge the gap between physical hardware and digital networks.",
    image:"https://images.unsplash.com/photo-1526481280695-3c687fd5432c",
  },
  {
    icon: <FaMobileAlt />,
    title: "Mobile & Web Applications",
    description:"We build high-performance cross-platform mobile apps and cloud-native web platforms. Our applications feature clean architectures, fast load times, and intuitive interfaces optimized for modern users.",
    image:
      "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c",
  },
  {
    icon: <FaHashtag />,
    title: "Cloud & Data Pipeline Integration",
    description:"We construct secure, closed-loop telemetry pipelines that seamlessly ingest data from sensors directly to cloud infrastructure. Achieve real-time visibility with robust data lakes and custom analytics dashboards.",
    image:
      "https://images.unsplash.com/photo-1557804506-669a67965ba0",
  },
  {
    icon: <FaCogs />,
    title: "DevSecOps & System Maintenance",
    description:"We offer continuous monitoring, threat detection, and proactive firmware/software updates. Keep your critical AI models, IoT grids, and software ecosystems stable, secure, and running with zero downtime.",
    image:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
  },
];

export default function Services() {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const cardsRef = useRef([]);

  const cardTitleColors = ["#f36b08", "#fff", "#08469a"];

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%",
        },
      });

      // HEADER ANIMATION (XABLE STYLE)
      tl.from(titleRef.current, {
        y: 80,
        opacity: 0,
        skewY: 4,
        duration: 1.2,
        ease: "power4.out",
      });

      tl.from(
        textRef.current,
        {
          y: 40,
          opacity: 0,
          duration: 1,
          ease: "power3.out",
        },
        "-=0.6"
      );

      // CARDS
      gsap.from(cardsRef.current, {
        y: 70,
        opacity: 0,
        scale: 0.95,
        duration: 1,
        ease: "power4.out",
        stagger: 0.15,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
        },
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section id="services" className="services-xable" ref={sectionRef}>
      <div className="container">

        {/* HEADER (XABLE STYLE) */}
        <div className="row align-items-end services-header">

          {/* LEFT */}
          <div className="col-lg-6">
            <span className="tag">OUR SERVICES</span>

            <h2 ref={titleRef}>
              Delivering premium AI, IoT <span style={{'color' : '#08469a'}}>& software solutions</span>
            </h2>
          </div>

          {/* RIGHT */}
          <div className="col-lg-6">
            <div ref={textRef}>
              <p>
                Glintgan Technologies design intelligent systems that scale, automate and transform businesses
                with modern engineering and design thinking.
              </p>
            </div>
          </div>

        </div>

        {/* GRID */}
        {/* <div className="services-grid">
          {services.map((s, i) => (
            <div
              key={i}
              className="cta-card"
              ref={(el) => (cardsRef.current[i] = el)}
            >

              <div
                className="cta-image"
                // style={{ backgroundImage: `url(${s.image})` }}
              />

              <div className="cta-overlay"></div>

              <div className="cta-content">
                <h3>{s.title}</h3>
                <p>{s.description}</p>
                <a href="#">Service Details »</a>
              </div>

            </div>
          ))}
        </div> */}

      <div className="services-grid">
  {services.map((s, i) => (
    <div
      key={i}
      className="cta-card"
      ref={(el) => (cardsRef.current[i] = el)}
    >
      <div
        className="cta-image"
        // style={{ backgroundImage: `url(${s.image})` }}
      />

      <div className="cta-overlay"></div>

      <div className="cta-content">
        {/* <div className="cta-icon">{s.icon}</div> */}

        <h3
          style={{
            color: cardTitleColors[i % cardTitleColors.length],
          }}
        >
          {s.title}
        </h3>

        <p>{s.description}</p>

        <a href="#">Service Details »</a>
      </div>
    </div>
  ))}
</div>
        

      </div>
    </section>
  );
}